import { Fragment } from "react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import dayjs from "dayjs";
import Slider from "react-slick";

import { ReactComponent as BgOverlay } from "../../../static/svg/event.svg";
import {
  Box,
  Card,
  CardMedia,
  Grid,
  IconButton,
  Typography,
  Zoom,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import Pagination from "../../UI/Pagination";
import AllresHeader from "../SubComponents/AllresHeader";
import ResCard from "../SubComponents/ResCard";

import MHSubscribe from "../../Layout/MHSubscribe";
import MHFooter from "../../Layout/MHFooter";
import { compareStartTimeAsc } from "../../../utils/utils";
// import EventFilter from "./EventFilter";
import EventMobileFilter from "../Articles/ArticleMobileFilter";
import EventFilter from "./EventFilter";
import AnimatedLoaderText from "../../Common/Loading/AnimatedLoaderText";
import { ResourcesData } from "../../NewLanding/EventGlance";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";

type ResProps = {
  thumbNailImageSrc?: string;
  itemList?: string[];
  title?: string;
  texts?: string;
  description?: string;
  categ?: string;
  id?: number;
  slug?: string;
  startTime?: string;
  createdDate?: string;
  updatedAt?: string;
};

const EventsPage = (props: ResProps) => {
  const theme = useTheme();
  const matchesMdDown = useMediaQuery(theme.breakpoints.down("md"));

  const location = useLocation();

  const [summitData, setSummitData] = useState<ResourcesData[]>([]); // ← fix
  const [summitPastData, setSummitPastData] = useState<ResourcesData[]>([]); // ← fix

  // const [resources, setResources] = useState<ResourceItemType[]>([]);
  let [count] = useState(0);

  var resUrl = `${process.env.REACT_APP_RES_EVENT_URL}`;

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(11);

  // Filtered resources using startTime
  const dateFilteredData = summitData.sort(compareStartTimeAsc);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = dateFilteredData.slice(firstPostIndex, lastPostIndex);
  // console.log(currentPosts, "currentPosts");

  // const [pastEvents, setPastEvents] = useState<ResourceItemType[]>([]);

  const [noOfElement, setnoOfElement] = useState(4);
  const slice = summitPastData.slice(0, noOfElement);

  if (dateFilteredData.length === 0) {
    console.log("erorr");
  }

  // console.log("fewEvents", fewEvents);
  // console.log("fewPastEvents", fewPastEvents);

  useEffect(() => {
    const getResources = async () => {
      try {
        const collectionRef = collection(db, "caf-summit-list");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));

        setSummitData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getResources();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const collectionRef = collection(db, "caf-past-summit");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));

        setSummitPastData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const settings = {
    centerMode: true,
    centerPadding: "22px",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: false,
    // autoplaySpeed: 1500,
    // beforeChange: (current, next) => setSlideIndex(next),
  };

  if (!summitData || !summitPastData.length)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <Fragment>
      <AllresHeader
        headerClassName="relative px-12 lg:px-0 text-center mx-auto w-full mx-auto md:pl-0 h-[450px] md:h-[450px] lg:h-[500px] bg-lilac-300 overflow-hidden"
        majorClassName="absolute top-14 md:top-12 md:inset-x-[18%] lg:top-24 lg:inset-x-[55%] text-center place-content-center"
        boxClassName="md:place-content-start pl-12 md:pl-0 ml-12 md:ml-0 place-content-start md:overscroll-x-hidden md:gap-2 flex md:pb-4"
        podClassName="hidden md:hidden"
        title="Events"
        titleInfo="from monthly workshops to yearly summits"
        titleExt="Find the Event for You"
        titleInfoclassName="text-center md:text-start mb-6 w-[60%] md:w-full font-columbia text-5xl capitalize font-semibold"
        pageInfo=""
        eventSocialClassName="block"
        pageInfoClassName="font-semibold text-center md:text-left w-[70%] -ml-8 md:ml-0 md:w-full text-[14px] font-areaSemi"
        ResIconUrl="https://res.cloudinary.com/mother-honestly/image/upload/v1661645343/image_3_woz2ng.png"
        BgUrl="https://mh-resources-production.s3.us-west-1.amazonaws.com/prosper1.jpg"
      >
        <BgOverlay
          className="overflow-hidden hidden md:block  absolute bottom-0 -right-20"
          height="300px"
          width="300px"
        />
        <BgOverlay
          className="overflow-hidden md:hidden  block absolute -top-28 -left-24 -scale-100"
          height="300px"
          width="300px"
        />
      </AllresHeader>

      {/* SEARCH FILTER */}
      <Typography
        color="primary"
        className=" lg:hidden block capitalize text-center pt-4 pb-2 opacity-50 text-[12px] font-areaSemi"
      >
        {summitData.length} Results
      </Typography>

      {matchesMdDown ? (
        <EventMobileFilter />
      ) : (
        <EventFilter totalRecords={summitData.length} />
      )}

      {/* SEARCH FILTER */}

      <>
        <Box className="mx-auto pt-10 bg-white px-4 md:px-20 pb-4">
          <Grid container spacing={2}>
            {currentPosts.map((res, index) => (
              <>
                <p className="hidden"> {(count = count + 1)}</p>

                {count === 1 ? (
                  <Grid item xs={12} md={12} lg={6}>
                    <Zoom in style={{ transitionDelay: "200ms" }}>
                      <Card
                        className={`relative w-auto h-[452px] object-cover bg-sky-400 rounded-md`}
                      >
                        {/* Overlay for Image */}
                        <Box className="bg-[#194049] h-full w-full object-cover absolute top-0 opacity-50 rounded-md"></Box>

                        <IconButton
                          disabled
                          className="absolute outline-none top-[6%] left-[6%]"
                        >
                          {/* Upcoming Event Icon */}
                          <img
                            className="h-6 w-6"
                            src="https://res.cloudinary.com/mother-honestly/image/upload/v1661645343/image_3_woz2ng.png"
                            alt="Resource Image"
                          />

                          <Typography className="ml-2 uppercase font-areaExt text-xs font-[900] leading-[102%] tracking-[0.1rem] text-white">
                            upcoming event
                          </Typography>
                        </IconButton>
                        <Box className="text-left w-full   absolute top-[20%] left-[6%]">
                          <Typography className=" capitalize line-clamp-2  w-4/5 font-columbia text-[28px] leading-[143%] tracking-[-0.04rem] font-[500] text-white">
                            {res.title}
                          </Typography>
                          <Typography className="pt-4 uppercase w-full font-areaExt text-[11px] font-[900] leading-[102%] tracking-[0.1rem] text-white">
                            {/* {dayjs(res.startTime!).format("MMMM D, h:mma")} */}
                            {dayjs(res.eventDate).format("MMMM D")}
                          </Typography>

                          <Typography className="pt-4  w-3/4 font-areaSemi line-clamp-2 text-[15px] font-[700] leading-[200%] tracking-[0.02rem]  text-white">
                            {res.caption}
                          </Typography>

                          <Box className="pt-12 space-x-4">
                            <Link
                              to={`${location.pathname}/${res.slug}
                      `}
                              className="bg-white w-[108px] no-underline px-6 py-4 h-[45px] text-navy-900 font-areaSemi not-italic text-[12px] font-[700] leading-[102%] tracking-[0.05rem]"
                            >
                              Reserve A Seat
                            </Link>
                            <Link
                              to={`/videos
                      `}
                              target="_blanc"
                              className="bg-white w-[120px] no-underline px-8 py-4 h-[45px] text-navy-900 font-areaSemi not-italic text-[12px] font-[700] leading-[102%] tracking-[0.05rem]"
                            >
                              Watch Video
                            </Link>
                          </Box>
                        </Box>
                        <CardMedia
                          className="object-cover h-[452px]"
                          component="img"
                          image={res.imgSrc}
                          // image="https://res.cloudinary.com/mother-honestly/image/upload/v1661545700/image_hsichu.png"
                          alt="Resource Image"
                        />
                      </Card>
                    </Zoom>
                  </Grid>
                ) : count >= 2 ? (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    key={index}
                    className="cardozo md:px-3 px-11 mt-6 md:mt-0"
                  >
                    <ResCard
                      cardClass="relative w-[305px] mb-10 h-[452px] object-cover bg-cream-100 rounded-md shadow-sm"
                      iconClass="hidden absolute top-10 ml-20 mt-12 w-20 h-20" //absolute top-10 ml-20 mt-12 w-20 h-20
                      imgBg="bg-pink-700 h-[305px]"
                      bodyBg="bg-cream-100"
                      top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                      imageSrc={res.imgSrc}
                      podTop="hidden"
                      title={res.title}
                      venue={res.venue}
                      eventType={res.eventType}
                      titleUrl={`/events/${res.slug}`}
                      playUrl={`/events/${res.slug}`}
                    />
                  </Grid>
                ) : (
                  ""
                )}
              </>
            ))}
          </Grid>
        </Box>

        <Pagination
          totalPosts={summitData.length}
          postsPerPage={postsPerPage}
          onClick={() => {
            setCurrentPage(currentPage - 1);
          }}
          onClicked={() => {
            setCurrentPage(currentPage + 1);
          }}
          currentPage={currentPage}
        />

        {/* For Mobile */}
        <Box className="mx-auto pt-10 md:hidden block bg-white px-4 py-4 overflow-x-hidden">
          <Typography
            variant="h1"
            color="primary"
            className="font-areaSemi text-xl text-center py-12"
          >
            Past Events You Might Like
          </Typography>
          <Slider {...settings}>
            {summitPastData.map((res, index) => (
              <Grid item xs={12} md={6} lg={3} key={index}>
                <ResCard
                  cardClass="relative w-[305px] mb-10 h-[452px] object-cover bg-cream-100 rounded-md shadow-sm"
                  iconClass="absolute top-14 left-[38%] mt-12 w-20 h-20" //absolute top-10 ml-20 mt-12 w-20 h-20
                  imgBg="bg-pink-700 h-[305px]"
                  bodyBg="bg-cream-100"
                  top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                  imageSrc={res.imgSrc}
                  podTop="hidden"
                  title={res.title}
                  venue={res.venue}
                  eventType={res.eventType}
                  titleUrl={`/events/past/${res.slug}`}
                  playUrl={`/events/past/${res.slug}`}
                />
              </Grid>
            ))}
          </Slider>
        </Box>

        {/* For Web */}
        <Box className="mx-auto pt-10 hidden md:block bg-white px-12 md:px-20 py-4">
          <Typography
            variant="h1"
            color="primary"
            className="font-areaSemi text-xl text-center py-12"
          >
            Past Events You Might Like
          </Typography>
          <Grid
            container
            spacing={2}
            className=" place-content-center place-items-center"
          >
            {slice.map((res, index) => (
              <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
                <ResCard
                  cardClass="relative w-[305px] mb-10 h-[452px] object-cover bg-cream-100 rounded-md shadow-sm"
                  iconClass="absolute top-14 left-[38%] mt-12 w-20 h-20" //absolute top-10 ml-20 mt-12 w-20 h-20
                  imgBg="bg-pink-700 h-[305px]"
                  bodyBg="bg-cream-100"
                  top={dayjs(res.eventDate).format("MMMM D")} // Use res.startTime directly
                  imageSrc={res.imgSrc}
                  podTop="hidden"
                  title={res.title}
                  venue={res.venue}
                  eventType={res.eventType}
                  titleUrl={`/events/past/${res.slug}`}
                  playUrl={`/events/past/${res.slug}`}
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <MHSubscribe />
        <MHFooter />
      </>
    </Fragment>
  );
};

export default EventsPage;
